import type { OrganizationResponse } from '../../api/organization-client/organization-client.type';
import { FeatureFlag } from './feature-flags.type';

/**
 * Checks if a feature flag is enabled for an organization
 * @param {OrganizationResponse | null} organization - The organization object
 * @param {FeatureFlag} flagKey - The feature flag key to check
 * @returns boolean indicating if the feature is enabled
 */
const isFeatureFlagEnabled = (organization: OrganizationResponse | null, flagKey: FeatureFlag): boolean => {
  if (!organization || !organization.feature_flags) {
    return false;
  }
  return organization.feature_flags[flagKey] === true;
};

export { isFeatureFlagEnabled };
